/* istanbul ignore file */

const getInternal = () =>
    Object.freeze({
        PRODUCTION: process.env.NODE_ENV === "production",
        DEVELOPMENT: process.env.NODE_ENV === "development",
        DEV_URL_OVERRIDE: process.env.DEV_URL_OVERRIDE || "",
        NODE_ENV: process.env.NODE_ENV,
        APP_BLOB_STORAGE_PATH: "/static-content",
        USEDEVESI: process.env.USEDEVESI,
    })

const INTERNAL = getInternal()

const getEnvVars = () =>
    Object.freeze({
        // prettier-ignore
        REACT_APP_BLOB_STORAGE_SSR_BASEURL:
            process.env.REACT_APP_BLOB_STORAGE_SSR_BASEURL || "https://ecmbrowsefdsxeuw.azurefd.net",
        PORT: process.env.PORT || 3004,
        REACT_APP_API_BASEURL: process.env.REACT_APP_API_BASEURL
            ? process.env.REACT_APP_API_BASEURL
            : "https://ci-test.next.co.uk/api/header",
        REACT_APP_MEGANAV_API_BASEURL: process.env.REACT_APP_MEGANAV_API_BASEURL
            ? process.env.REACT_APP_MEGANAV_API_BASEURL
            : "https://ci-test.next.co.uk/api/meganav",
        REACT_APP_PRS_API_BASEURL: process.env.REACT_APP_PRS_API_BASEURL
            ? process.env.REACT_APP_PRS_API_BASEURL
            : "https://ci-test.next.co.uk",
        POD_NAME: process.env.POD_NAME,
        REACT_APP_SERVE_PATH_PREFIX: process.env.REACT_APP_SERVE_PATH_PREFIX || "",
        ASSETS_PATH: process.env.ASSETS_PATH || "/headerstatic",
        LOG_LEVEL: process.env.LOG_LEVEL,
        FNC_NAME: process.env.FNC_NAME,
        REACT_APP_APPINSIGHTS_KEY: process.env.REACT_APP_APPINSIGHTS_KEY,
        BLOOMREACH_BASE_URL: process.env.BLOOMREACH_BASE_URL || "https://brm-suggest-0.brsrvr.com/api/v1/suggest/",
        REACT_APP_MEGANAV_BASEURL:
            process.env.REACT_APP_MEGANAV_BASEURL ||
            (INTERNAL.DEVELOPMENT || INTERNAL.USEDEVESI ? "http://localhost:3005" : ""),
        REACT_APP_MEGANAV_ASSETS_PATH: process.env.REACT_APP_MEGANAV_ASSETS_PATH || "/meganavstatic",
        GEOLOCATION_BASEURL:
            process.env.REACT_APP_GEOLOCATION_BASEURL || "https://services-uat.test.ecomm.systems.next/geolocation",
        ENVIRONMENT: process.env.ENVIRONMENT || "dev",
        REACT_APP_USE_TIME_MACHINE_COOKIE: process.env.REACT_APP_USE_TIME_MACHINE_COOKIE || "false",
        USE_LOCAL_STATIC_CONTENT: process.env.USE_LOCAL_STATIC_CONTENT || "true",
        REACT_APP_LAUNCH_DARKLY_APP_ID: process.env.REACT_APP_LAUNCH_DARKLY_APP_ID || "sx-launch-darkly-app-id",
        REACT_APP_LAUNCH_DARKLY_SDK_KEY: process.env.REACT_APP_LAUNCH_DARKLY_SDK_KEY,
        REACT_APP_LAUNCH_DARKLY_BASE_URI: process.env.REACT_APP_LAUNCH_DARKLY_BASE_URI,
        REACT_APP_LAUNCH_DARKLY_EVENTS_URI: process.env.REACT_APP_LAUNCH_DARKLY_EVENTS_URI,
        REACT_APP_LAUNCH_DARKLY_STREAM_URI: process.env.REACT_APP_LAUNCH_DARKLY_STREAM_URI,
        ENVIRONMENT_NAME: process.env.ENVIRONMENT_NAME || "pd",
    })

export const getVars = () => ({...INTERNAL, ...getEnvVars()})

export default getVars()
